export default "__VITE_ASSET__CQHfAR5i__"